import React from "react"

class BookingButton extends React.Component {

	constructor(props) {
		super(props);
	}

	render() {
		var style = $.extend({backgroundColor: this.props.button_background_color, color: this.props.button_font_color}, this.borderRadius());

		if (typeof this.props.position_override !== 'undefined') {
			style['position'] = this.props.position_override;
		}

		return (
			<div className={this.classes()} style={style}>{this.props.text}</div>
		);
	}

	/**
	* Helper Functions 
	*/

	borderRadius() {
		if (this.props.rounded_corners == 0) {
			return {};
		} else {
			if (this.props.style == 'button') {
				return {borderRadius: this.props.rounded_corners + 'px'};
			} else {
				/* tab style */
				if (this.props.position == 'top_left' || this.props.position == 'top_right') {
					return {
						borderTopLeftRadius: 0,
						borderTopRightRadius: 0,
						borderBottomLeftRadius: this.props.rounded_corners + 'px',
						borderBottomRightRadius: this.props.rounded_corners + 'px',
					};
				} else if (this.props.position == 'bottom_left' || this.props.position == 'bottom_right') {
					return {
						borderTopLeftRadius: this.props.rounded_corners + 'px',
						borderTopRightRadius: this.props.rounded_corners + 'px',
						borderBottomLeftRadius: 0,
						borderBottomRightRadius: 0,
					};
				}
			}
		}
	}

	classes() {
		var classes = 'booking-button';

		classes = classes + ' ' + this.props.position;
		classes = classes + ' ' + this.props.style;
		classes = classes + ' ' + this.props.size;

		return classes;
	}

}

export default BookingButton